import { AdditionalRequirementsProps, ConsentOrdersPathName, FormNavigation, Stepper, toast } from "@fla/components";
import DollarIcon from "@fla/components/src/assets/svgs/file_dollar.svg";
import { useAppDispatch } from "app/store";
import { useConsentOrders } from "hooks/ConsentOrders";
import { SliceStatus } from "interfaces";
import { selectBaseAssetsDebts } from "pages/ConsentOrders";
import { consentOrdersActions } from "pages/ConsentOrders/consentOrdersSlice";
import { useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";

import { formSteps } from "./steps";

const initialState = {
  if_additional_payments: "",
  payments: [],
  if_dividing_assets_debts: "",
  details: ""
};

export default function AddiontalRequirements() {
  const location = useLocation() as any;

  const navigation = useNavigate();
  const dispatch = useAppDispatch();
  const assetsDebts = useSelector(selectBaseAssetsDebts);
  const [status, setStatus] = useState(SliceStatus.Idle);

  const [currentStep, setCurrentStep] = useState(1);
  const [formState, setFormState] = useState(
    useMemo(() => {
      if (assetsDebts?.additional_requirements) {
        return assetsDebts?.additional_requirements.data as AdditionalRequirementsProps;
      } else {
        return initialState;
      }
    }, [assetsDebts])
  );

  const CurrentTab = formSteps[currentStep as keyof typeof formSteps];

  const isLastStep = () => currentStep === Object.keys(formSteps).length;
  const isFirstStep = () => currentStep === 1;

  const isLast = isLastStep();
  const isFirst = isFirstStep();

  const { updateAssetsDebts } = useConsentOrders();

  const handleBackClick = () => {
    if (!isFirst) {
      setCurrentStep(prev => prev - 1);
    } else {
      navigation(ConsentOrdersPathName.Debts, {
        state: location.state?.parent,
        replace: true
      });
    }
  };

  const onSubmit = async (formData: AdditionalRequirementsProps) => {
    setFormState(prevState => ({ ...prevState, ...formData }));

    if (!isLast) setCurrentStep(prev => prev + 1);
    else {
      try {
        setStatus(SliceStatus.Pending);

        const payload = {
          additional_requirements: { data: formData, isCompleted: true },
          currentStep: 11
        };
        await updateAssetsDebts(payload);

        dispatch(consentOrdersActions.setAssetsDebts(payload));
        setStatus(SliceStatus.Resolved);
        navigation(ConsentOrdersPathName.Summary);
      } catch (error: any) {
        setStatus(SliceStatus.Rejected);

        toast({
          type: "error",
          message: error?.message || "something went wrong, please try again!"
        });
      }
    }
  };

  return (
    <section className="w-full py-10">
      <div className="md:w-10/12 lg:max-w-2xl mx-auto h-fit px-5 md:px-10 md:py-5 space-y-5">
        <img src={DollarIcon} className="w-10 h-auto mx-auto my-3" alt="dollar" />

        <h3 className="text-center my-5">Additional Requirements</h3>

        <Stepper steps={[1, 2]} currentStep={currentStep} classes="max-w-[150px] !mx-auto" />

        <CurrentTab formId="add-req-form" store={formState} onSubmit={onSubmit} />

        <FormNavigation
          isFirst={false}
          isLast={isLast}
          form="add-req-form"
          handleBackClick={handleBackClick}
          nextButtonText="Continue"
          isSubmitting={status === SliceStatus.Pending}
          classes="pt-12"
        />
      </div>
    </section>
  );
}
